import type { ChatMessage } from './types';

export const demoConversations: ChatMessage[][] = [
  // Conversation 1: Follow-up identification
  [
    {
      id: '1',
      role: 'user',
      content: 'Who should I follow up with?',
      timestamp: new Date(Date.now() - 6 * 60 * 1000).toISOString(),
    },
    {
      id: '2',
      role: 'assistant',
      content:
        "Let me look at your deals and recent interactions to identify who needs follow-up.",
      streamComplete: true,
      timestamp: new Date(Date.now() - 5 * 60 * 1000).toISOString(),
      toolUses: [
        { label: 'Read follow-up candidates', expanded: false },
        { label: 'Read pending tasks', expanded: false },
        { label: 'Read open deals', expanded: false },
      ],
      sections: [
        {
          title: 'High Priority — Open Deals, Longest Since Last Contact',
          color: 'red',
          summary:
            'Clay Hinrichs MD is the most overdue — no contact in over 2 months on a $100K lead. Worth a direct outreach.',
          table: {
            headers: ['Contact', 'Company', 'Deal', 'Value', 'Last Interaction'],
            rows: [
              ['Clay Hinrichs MD', 'Medical Group of NJ - ImageCare Radiology', 'Lead', '$100K', 'Feb 10 (2+ months)'],
              ['Daniel Ploof', 'Bridgecare-Medical', 'In Progress', '$20K', 'Mar 26 (~3 weeks)'],
              ['—', 'Diamond Medical Associates', 'In Progress', '$24K', 'Apr 6 (~1 week ago)'],
            ],
          },
        },
        {
          title: 'Active — Keep Momentum',
          color: 'yellow',
          summary: '',
          table: {
            headers: ['Contact', 'Company', 'Deal', 'Value', 'Last Interaction'],
            rows: [
              ['Sarah Kim', 'Coastal Radiology', 'Negotiation', '$45K', 'Apr 12 (2 days)'],
              ['Dr. James Liu', 'Pacific Heart Center', 'Closed Won', '$85K', 'Apr 13 (1 day)'],
            ],
          },
        },
      ],
    },
  ],
  // Conversation 2: Critical patient attention
  [
    {
      id: '3',
      role: 'user',
      content: 'Which patients need immediate attention?',
      timestamp: new Date(Date.now() - 3 * 60 * 1000).toISOString(),
    },
    {
      id: '4',
      role: 'assistant',
      content:
        "Let me check all active patient vitals and flag anyone with critical readings that need immediate attention.",
      streamComplete: true,
      timestamp: new Date(Date.now() - 2 * 60 * 1000).toISOString(),
      toolUses: [
        { label: 'Read patient vitals', expanded: false },
        { label: 'Read alert thresholds', expanded: false },
        { label: 'Read pending alerts', expanded: false },
      ],
      sections: [
        {
          title: 'Critical — Immediate Action Required',
          color: 'red',
          summary:
            'Maria Gonzalez has critically high BP readings (189/102) — a direct call is strongly recommended before end of day.',
          table: {
            headers: ['Patient', 'Reading', 'Alert', 'Device', 'Last Sync'],
            rows: [
              ['Maria Gonzalez', '189/102', 'Critical', 'BP Monitor v2', '10 min ago'],
              ['Robert Chen', 'SpO2 87%', 'Critical', 'Pulse Oximeter', '25 min ago'],
            ],
          },
        },
        {
          title: 'Warning — Review Today',
          color: 'yellow',
          summary: '',
          table: {
            headers: ['Patient', 'Reading', 'Alert', 'Device', 'Last Sync'],
            rows: [
              ['Helen Torres', '165/95', 'Elevated', 'BP Monitor v2', '1 hour ago'],
              ['Frank Patel', 'Weight +3.2kg', 'Trending Up', 'Smart Scale', '3 hours ago'],
            ],
          },
        },
      ],
    },
  ],
];

export const suggestedQuestions = [
  'Who should I follow up with?',
  'Which patients need immediate attention?',
  'What\'s the summary for this week?',
  'Generate a care plan for a new patient',
];
